var cov_20mld0zqmv = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Table/resizable.tsx",
      hash = "702b49f5a4493a1a58cfabb13bd8d3b1f72198f7",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Table/resizable.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 78,
          column: 3
        }
      },
      "1": {
        start: {
          line: 12,
          column: 6
        },
        end: {
          line: 12,
          column: 18
        }
      },
      "2": {
        start: {
          line: 13,
          column: 6
        },
        end: {
          line: 13,
          column: 54
        }
      },
      "3": {
        start: {
          line: 14,
          column: 6
        },
        end: {
          line: 17,
          column: 7
        }
      },
      "4": {
        start: {
          line: 21,
          column: 26
        },
        end: {
          line: 21,
          column: 43
        }
      },
      "5": {
        start: {
          line: 22,
          column: 42
        },
        end: {
          line: 22,
          column: 52
        }
      },
      "6": {
        start: {
          line: 23,
          column: 6
        },
        end: {
          line: 38,
          column: 7
        }
      },
      "7": {
        start: {
          line: 24,
          column: 8
        },
        end: {
          line: 37,
          column: 9
        }
      },
      "8": {
        start: {
          line: 26,
          column: 10
        },
        end: {
          line: 26,
          column: 36
        }
      },
      "9": {
        start: {
          line: 28,
          column: 26
        },
        end: {
          line: 34,
          column: 16
        }
      },
      "10": {
        start: {
          line: 31,
          column: 16
        },
        end: {
          line: 33,
          column: 18
        }
      },
      "11": {
        start: {
          line: 32,
          column: 18
        },
        end: {
          line: 32,
          column: 64
        }
      },
      "12": {
        start: {
          line: 36,
          column: 10
        },
        end: {
          line: 36,
          column: 45
        }
      },
      "13": {
        start: {
          line: 42,
          column: 24
        },
        end: {
          line: 42,
          column: 34
        }
      },
      "14": {
        start: {
          line: 43,
          column: 26
        },
        end: {
          line: 43,
          column: 36
        }
      },
      "15": {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 48,
          column: 7
        }
      },
      "16": {
        start: {
          line: 45,
          column: 20
        },
        end: {
          line: 45,
          column: 71
        }
      },
      "17": {
        start: {
          line: 45,
          column: 47
        },
        end: {
          line: 45,
          column: 67
        }
      },
      "18": {
        start: {
          line: 46,
          column: 18
        },
        end: {
          line: 46,
          column: 42
        }
      },
      "19": {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 47,
          column: 32
        }
      },
      "20": {
        start: {
          line: 49,
          column: 6
        },
        end: {
          line: 49,
          column: 18
        }
      },
      "21": {
        start: {
          line: 53,
          column: 6
        },
        end: {
          line: 53,
          column: 40
        }
      },
      "22": {
        start: {
          line: 53,
          column: 34
        },
        end: {
          line: 53,
          column: 40
        }
      },
      "23": {
        start: {
          line: 54,
          column: 33
        },
        end: {
          line: 54,
          column: 43
        }
      },
      "24": {
        start: {
          line: 55,
          column: 22
        },
        end: {
          line: 64,
          column: 8
        }
      },
      "25": {
        start: {
          line: 56,
          column: 23
        },
        end: {
          line: 56,
          column: 43
        }
      },
      "26": {
        start: {
          line: 58,
          column: 8
        },
        end: {
          line: 58,
          column: 81
        }
      },
      "27": {
        start: {
          line: 59,
          column: 8
        },
        end: {
          line: 59,
          column: 31
        }
      },
      "28": {
        start: {
          line: 60,
          column: 8
        },
        end: {
          line: 63,
          column: 10
        }
      },
      "29": {
        start: {
          line: 61,
          column: 20
        },
        end: {
          line: 61,
          column: 31
        }
      },
      "30": {
        start: {
          line: 62,
          column: 10
        },
        end: {
          line: 62,
          column: 30
        }
      },
      "31": {
        start: {
          line: 62,
          column: 17
        },
        end: {
          line: 62,
          column: 30
        }
      },
      "32": {
        start: {
          line: 65,
          column: 6
        },
        end: {
          line: 68,
          column: 7
        }
      },
      "33": {
        start: {
          line: 66,
          column: 8
        },
        end: {
          line: 66,
          column: 39
        }
      },
      "34": {
        start: {
          line: 67,
          column: 8
        },
        end: {
          line: 67,
          column: 14
        }
      },
      "35": {
        start: {
          line: 69,
          column: 6
        },
        end: {
          line: 69,
          column: 28
        }
      },
      "36": {
        start: {
          line: 73,
          column: 26
        },
        end: {
          line: 73,
          column: 36
        }
      },
      "37": {
        start: {
          line: 74,
          column: 43
        },
        end: {
          line: 74,
          column: 53
        }
      },
      "38": {
        start: {
          line: 75,
          column: 20
        },
        end: {
          line: 75,
          column: 35
        }
      },
      "39": {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 76,
          column: 103
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 16
          },
          end: {
            line: 9,
            column: 17
          }
        },
        loc: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 78,
            column: 3
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 11,
            column: 5
          }
        },
        loc: {
          start: {
            line: 11,
            column: 56
          },
          end: {
            line: 18,
            column: 5
          }
        },
        line: 11
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 20,
            column: 5
          }
        },
        loc: {
          start: {
            line: 20,
            column: 67
          },
          end: {
            line: 39,
            column: 5
          }
        },
        line: 20
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 30,
            column: 29
          },
          end: {
            line: 30,
            column: 30
          }
        },
        loc: {
          start: {
            line: 30,
            column: 38
          },
          end: {
            line: 34,
            column: 15
          }
        },
        line: 30
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 31,
            column: 30
          },
          end: {
            line: 31,
            column: 31
          }
        },
        loc: {
          start: {
            line: 31,
            column: 49
          },
          end: {
            line: 33,
            column: 17
          }
        },
        line: 31
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 41,
            column: 5
          }
        },
        loc: {
          start: {
            line: 41,
            column: 15
          },
          end: {
            line: 50,
            column: 5
          }
        },
        line: 41
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 45,
            column: 35
          },
          end: {
            line: 45,
            column: 36
          }
        },
        loc: {
          start: {
            line: 45,
            column: 47
          },
          end: {
            line: 45,
            column: 67
          }
        },
        line: 45
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        },
        loc: {
          start: {
            line: 52,
            column: 67
          },
          end: {
            line: 70,
            column: 5
          }
        },
        line: 52
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 55,
            column: 40
          },
          end: {
            line: 55,
            column: 41
          }
        },
        loc: {
          start: {
            line: 55,
            column: 49
          },
          end: {
            line: 64,
            column: 7
          }
        },
        line: 55
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 60,
            column: 30
          },
          end: {
            line: 60,
            column: 31
          }
        },
        loc: {
          start: {
            line: 60,
            column: 42
          },
          end: {
            line: 63,
            column: 9
          }
        },
        line: 60
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 72,
            column: 5
          }
        },
        loc: {
          start: {
            line: 72,
            column: 13
          },
          end: {
            line: 77,
            column: 5
          }
        },
        line: 72
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 23,
            column: 6
          },
          end: {
            line: 38,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 6
          },
          end: {
            line: 38,
            column: 7
          }
        }, {
          start: {
            line: 23,
            column: 6
          },
          end: {
            line: 38,
            column: 7
          }
        }],
        line: 23
      },
      "1": {
        loc: {
          start: {
            line: 24,
            column: 8
          },
          end: {
            line: 37,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 24,
            column: 8
          },
          end: {
            line: 37,
            column: 9
          }
        }, {
          start: {
            line: 24,
            column: 8
          },
          end: {
            line: 37,
            column: 9
          }
        }],
        line: 24
      },
      "2": {
        loc: {
          start: {
            line: 28,
            column: 26
          },
          end: {
            line: 34,
            column: 16
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 29,
            column: 14
          },
          end: {
            line: 29,
            column: 21
          }
        }, {
          start: {
            line: 30,
            column: 14
          },
          end: {
            line: 34,
            column: 16
          }
        }],
        line: 28
      },
      "3": {
        loc: {
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 48,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 48,
            column: 7
          }
        }, {
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 48,
            column: 7
          }
        }],
        line: 44
      },
      "4": {
        loc: {
          start: {
            line: 45,
            column: 52
          },
          end: {
            line: 45,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 45,
            column: 52
          },
          end: {
            line: 45,
            column: 61
          }
        }, {
          start: {
            line: 45,
            column: 65
          },
          end: {
            line: 45,
            column: 66
          }
        }],
        line: 45
      },
      "5": {
        loc: {
          start: {
            line: 47,
            column: 15
          },
          end: {
            line: 47,
            column: 32
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 47,
            column: 25
          },
          end: {
            line: 47,
            column: 26
          }
        }, {
          start: {
            line: 47,
            column: 29
          },
          end: {
            line: 47,
            column: 32
          }
        }],
        line: 47
      },
      "6": {
        loc: {
          start: {
            line: 53,
            column: 6
          },
          end: {
            line: 53,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 6
          },
          end: {
            line: 53,
            column: 40
          }
        }, {
          start: {
            line: 53,
            column: 6
          },
          end: {
            line: 53,
            column: 40
          }
        }],
        line: 53
      },
      "7": {
        loc: {
          start: {
            line: 58,
            column: 43
          },
          end: {
            line: 58,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 58,
            column: 43
          },
          end: {
            line: 58,
            column: 55
          }
        }, {
          start: {
            line: 58,
            column: 59
          },
          end: {
            line: 58,
            column: 74
          }
        }, {
          start: {
            line: 58,
            column: 78
          },
          end: {
            line: 58,
            column: 79
          }
        }],
        line: 58
      },
      "8": {
        loc: {
          start: {
            line: 62,
            column: 10
          },
          end: {
            line: 62,
            column: 30
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 62,
            column: 10
          },
          end: {
            line: 62,
            column: 30
          }
        }, {
          start: {
            line: 62,
            column: 10
          },
          end: {
            line: 62,
            column: 30
          }
        }],
        line: 62
      },
      "9": {
        loc: {
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 68,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 68,
            column: 7
          }
        }, {
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 68,
            column: 7
          }
        }],
        line: 65
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0, 0],
      "8": [0, 0],
      "9": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Table/resizable.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import immer from 'immer';
export default (function (Table) {
  cov_20mld0zqmv.f[0]++;
  cov_20mld0zqmv.s[0]++;
  return (
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(_class, _React$Component);

      var _super = _createSuper2(_class);

      function _class(props) {
        var _this;

        _classCallCheck(this, _class);

        cov_20mld0zqmv.f[1]++;
        cov_20mld0zqmv.s[1]++;
        _this = _super.call(this, props);
        cov_20mld0zqmv.s[2]++;
        _this.handleResize = _this.handleResize.bind(_assertThisInitialized(_this));
        cov_20mld0zqmv.s[3]++;
        _this.state = {
          columns: props.columns,
          delta: 0
        };
        return _this;
      }

      _createClass(_class, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var _this2 = this;

          cov_20mld0zqmv.f[2]++;
          var prevColumns = (cov_20mld0zqmv.s[4]++, prevProps.columns);

          var _ref = (cov_20mld0zqmv.s[5]++, this.props),
              columns = _ref.columns,
              onColumnResize = _ref.onColumnResize;

          cov_20mld0zqmv.s[6]++;

          if (prevColumns !== columns) {
            cov_20mld0zqmv.b[0][0]++;
            cov_20mld0zqmv.s[7]++;

            if (prevColumns.length !== columns.length) {
              cov_20mld0zqmv.b[1][0]++;
              cov_20mld0zqmv.s[8]++;
              // eslint-disable-next-line react/no-did-update-set-state
              this.setState({
                columns: columns
              });
            } else {
              cov_20mld0zqmv.b[1][1]++;
              var widthed = (cov_20mld0zqmv.s[9]++, onColumnResize ? (cov_20mld0zqmv.b[2][0]++, columns) : (cov_20mld0zqmv.b[2][1]++, immer(columns, function (draft) {
                cov_20mld0zqmv.f[3]++;
                cov_20mld0zqmv.s[10]++;
                draft.forEach(function (column, index) {
                  cov_20mld0zqmv.f[4]++;
                  cov_20mld0zqmv.s[11]++;
                  column.width = _this2.state.columns[index].width;
                });
              }))); // eslint-disable-next-line react/no-did-update-set-state

              cov_20mld0zqmv.s[12]++;
              this.setState({
                columns: widthed
              });
            }
          } else {
            cov_20mld0zqmv.b[0][1]++;
          }
        }
      }, {
        key: "getWidth",
        value: function getWidth() {
          cov_20mld0zqmv.f[5]++;

          var _ref2 = (cov_20mld0zqmv.s[13]++, this.props),
              width = _ref2.width;

          var _ref3 = (cov_20mld0zqmv.s[14]++, this.state),
              columns = _ref3.columns;

          cov_20mld0zqmv.s[15]++;

          if (typeof width === 'number') {
            cov_20mld0zqmv.b[3][0]++;
            var sum = (cov_20mld0zqmv.s[16]++, columns.reduce(function (s, col) {
              cov_20mld0zqmv.f[6]++;
              cov_20mld0zqmv.s[17]++;
              return s + ((cov_20mld0zqmv.b[4][0]++, col.width) || (cov_20mld0zqmv.b[4][1]++, 0));
            }, 0));
            var w = (cov_20mld0zqmv.s[18]++, width + this.state.delta);
            cov_20mld0zqmv.s[19]++;
            return w > sum ? (cov_20mld0zqmv.b[5][0]++, w) : (cov_20mld0zqmv.b[5][1]++, sum);
          } else {
            cov_20mld0zqmv.b[3][1]++;
          }

          cov_20mld0zqmv.s[20]++;
          return width;
        }
      }, {
        key: "handleResize",
        value: function handleResize(index, width, colgroup) {
          cov_20mld0zqmv.f[7]++;
          cov_20mld0zqmv.s[21]++;

          if (colgroup === undefined) {
            cov_20mld0zqmv.b[6][0]++;
            cov_20mld0zqmv.s[22]++;
            return;
          } else {
            cov_20mld0zqmv.b[6][1]++;
          }

          var _ref4 = (cov_20mld0zqmv.s[23]++, this.props),
              onColumnResize = _ref4.onColumnResize;

          var changed = (cov_20mld0zqmv.s[24]++, immer(this.state, function (draft) {
            cov_20mld0zqmv.f[8]++;
            var column = (cov_20mld0zqmv.s[25]++, draft.columns[index]); // @ts-ignore

            cov_20mld0zqmv.s[26]++;
            draft.delta += parseFloat(width - ((cov_20mld0zqmv.b[7][0]++, column.width) || (cov_20mld0zqmv.b[7][1]++, colgroup[index]) || (cov_20mld0zqmv.b[7][2]++, 0)));
            cov_20mld0zqmv.s[27]++;
            colgroup[index] = width;
            cov_20mld0zqmv.s[28]++;
            draft.columns.forEach(function (col, i) {
              cov_20mld0zqmv.f[9]++;
              var w = (cov_20mld0zqmv.s[29]++, colgroup[i]);
              cov_20mld0zqmv.s[30]++;

              if (w) {
                cov_20mld0zqmv.b[8][0]++;
                cov_20mld0zqmv.s[31]++;
                col.width = w;
              } else {
                cov_20mld0zqmv.b[8][1]++;
              }
            });
          }));
          cov_20mld0zqmv.s[32]++;

          if (onColumnResize) {
            cov_20mld0zqmv.b[9][0]++;
            cov_20mld0zqmv.s[33]++;
            onColumnResize(changed.columns);
            cov_20mld0zqmv.s[34]++;
            return;
          } else {
            cov_20mld0zqmv.b[9][1]++;
          }

          cov_20mld0zqmv.s[35]++;
          this.setState(changed);
        }
      }, {
        key: "render",
        value: function render() {
          cov_20mld0zqmv.f[10]++;

          var _ref5 = (cov_20mld0zqmv.s[36]++, this.state),
              columns = _ref5.columns;

          var _ref6 = (cov_20mld0zqmv.s[37]++, this.props),
              onColumnResize = _ref6.onColumnResize,
              other = _objectWithoutProperties(_ref6, ["onColumnResize"]);

          var width = (cov_20mld0zqmv.s[38]++, this.getWidth());
          cov_20mld0zqmv.s[39]++;
          return (
            /*#__PURE__*/
            React.createElement(Table, Object.assign({}, other, {
              width: width,
              columns: columns,
              onResize: this.handleResize,
              __self: this,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 76,
                columnNumber: 14
              }
            }))
          );
        }
      }]);

      return _class;
    }(React.Component)
  );
});